import React from "react";
import { useTranslation } from "react-i18next";

// Content languages for catalog / sub-catalog / product name + description.
export const CONTENT_LANGS = [
  { code: "vi", flag: "🇻🇳" },
  { code: "en", flag: "🇬🇧" },
];

// Empty bilingual values for a form: { name_vi: "", name_en: "", ... }.
export const emptyBilingual = (fields) =>
  fields.reduce((acc, f) => {
    CONTENT_LANGS.forEach(({ code }) => (acc[`${f}_${code}`] = ""));
    return acc;
  }, {});

// Fill form values from an API row. Rows created before translations existed
// only have the legacy column, so that is used as the Vietnamese value.
export const bilingualFromRow = (row, fields) =>
  fields.reduce((acc, f) => {
    CONTENT_LANGS.forEach(({ code }) => {
      const v = row[`${f}_${code}`];
      acc[`${f}_${code}`] = v != null ? v : code === "vi" && row[`${f}_en`] == null ? row[f] || "" : "";
    });
    return acc;
  }, {});

export const hasAnyLang = (form, field) =>
  CONTENT_LANGS.some(({ code }) => String(form[`${field}_${code}`] || "").trim());

// Every stored translation of a field, for client-side search.
export const allLangValues = (row, field) => [row[field], ...CONTENT_LANGS.map(({ code }) => row[`${field}_${code}`])];

// Two inputs side by side (Vietnamese / English) for one field.
// `render(code, name, value)` lets callers supply a custom editor (e.g. HTML).
const BilingualField = ({ field, label, form, onChange, required, multiline, rows = 2, placeholder, render, maxLength }) => {
  const { t } = useTranslation();
  return (
    <div className="mb-3">
      <label className="form-label">
        {label}
        {required && " *"}
        {required && <span className="form-text ms-2">{t("bilingual.atLeastOne")}</span>}
      </label>
      <div className="row g-2">
        {CONTENT_LANGS.map(({ code, flag }) => {
          const name = `${field}_${code}`;
          const value = form[name] || "";
          const langLabel = (
            <span className="small text-muted d-block mb-1">
              {flag} {t(`language.${code}`)}
            </span>
          );
          return (
            <div className={render ? "col-12" : "col-md-6"} key={code}>
              {langLabel}
              {render ? (
                render(code, name, value)
              ) : multiline ? (
                <textarea className="form-control" name={name} value={value} onChange={onChange} rows={rows} placeholder={placeholder} lang={code} />
              ) : (
                <input type="text" className="form-control" name={name} value={value} onChange={onChange} placeholder={placeholder} maxLength={maxLength} lang={code} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BilingualField;
